module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-white-130724fe.png";